import { styled } from 'baseui'
import { FlexCenterY, FlexCenter } from '@/shared/theme/styled-components'

export const Placeholder = styled('div', ({ $theme }) => ({
  padding: '1rem',
  color: $theme.colors.textMuted,
  fontWeight: 600,
}))

export const PageContainer = styled('div', {
  width: '100%',
  boxSizing: 'border-box',
  padding: '1rem',
})

export const LayoutCard = styled('div', ({ $theme }) => ({
  backgroundColor: $theme.colors.white,
  borderRadius: '1rem',
  boxShadow: $theme.lighting.shadowElevated,
  display: 'grid',
  gridTemplateColumns: '16.25rem 1fr',
  gap: '1rem',
  padding: '1rem',
  alignItems: 'start',
}))

export const ContentArea = styled('main', {
  minWidth: 0,
})

export const SidebarCard = styled('aside', ({ $theme }) => ({
  backgroundColor: $theme.colors.white,
  borderRadius: '0.875rem',
  border: `0.0625rem solid ${$theme.colors.borderLight}`,
  padding: '0.75rem',
  boxSizing: 'border-box',
}))

export const SidebarItemButton = styled(FlexCenterY, ({ $theme, $active }) => ({
  width: '100%',
  gap: '0.6rem',
  padding: '0.65rem 0.75rem',
  borderRadius: '0.75rem',
  border: 'none',
  cursor: 'pointer',
  textAlign: 'left',
  fontWeight: 700,
  color: $theme.colors.textDark,
  backgroundColor: $active ? $theme.colors.bgActiveBlue : 'transparent',
}))

export const SidebarIconContainer = styled(FlexCenter, ({ $theme, $active }) => ({
  width: '1.875rem',
  height: '1.875rem',
  borderRadius: '0.625rem',
  border: `0.0625rem solid ${$theme.colors.borderLight}`,
  backgroundColor: $active ? $theme.colors.bgActiveBlueStrong : $theme.colors.bgSubtle,
  flexShrink: 0,
}))
